import React, {Component} from 'react';
import './square-animation.css';

// http://codepen.io/wontem/pen/YXzVyr
class SquareAnimationComponent extends Component {

  render() {
    return (
      <div className="square-animation">

        <div className="view">
          <div className="part">
            <div className="plane">
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="static">
                <div className="cube">
                  <div className="face x"></div>
                  <div className="face y"></div>
                  <div className="face z"></div>
                </div>
                <div className="cube">
                  <div className="face x"></div>
                  <div className="face y"></div>
                  <div className="face z"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="part">
            <div className="plane">
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="cube">
                <div className="face x"></div>
                <div className="face y"></div>
                <div className="face z"></div>
              </div>
              <div className="static">
                <div className="cube">
                  <div className="face x"></div>
                  <div className="face y"></div>
                  <div className="face z"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SquareAnimationComponent;



// WEBPACK FOOTER //
// ./src/components/square-animation/square-animation.jsx